// Module
var code = "<div ref=\"generatedFormContainer\" class=\"flex-container-column flex-item-auto w-100\">\n\n</div>";
// Exports
module.exports = code;